import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useRef } from "react";

import {
  getWarholOutputSettings,
  updateWarholOutputSettings,
} from "../../services/warhol-output-settings";

export const warholOutputSettingsKeys = {
  all: ["warhol-output-settings"] as const,
};

export function useWarholOutputSettingsQuery() {
  return useQuery({
    queryKey: warholOutputSettingsKeys.all,
    queryFn: getWarholOutputSettings,
  });
}

export function useUpdateWarholOutputSettingsMutation() {
  const queryClient = useQueryClient();
  const latestRequestRef = useRef(0);
  return useMutation({
    mutationFn: updateWarholOutputSettings,
    onMutate: () => {
      latestRequestRef.current += 1;
      return { requestId: latestRequestRef.current };
    },
    onSuccess: (data, _variables, context) => {
      // why: overlapping PUTs finish out of order — only the latest request may replace the cached draft.
      if (context?.requestId !== latestRequestRef.current) {
        return;
      }
      queryClient.setQueryData(warholOutputSettingsKeys.all, data);
    },
  });
}
